import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormHelperText from '@material-ui/core/FormHelperText';
import { NOT_FOUND } from 'http-status-codes';
import { Row } from 'components/UI/Row';
import { History } from 'history';
import { AuthForm } from 'components/AuthForm';
import { RecoverCode } from './RecoverCode';
import { axiosInstance } from '../axiosInstance';

const RecoverPassword = () => {
  const { t } = useTranslation();
  const [backendError, setBackendError] = useState<string>('');
  const history: History = useHistory();
  const { register, handleSubmit, errors, setError } = useForm<{ email: string }>();
  const onSubmit = useCallback(
    async ({ email }) => {
      try {
        await axiosInstance.post('/users/invalidate/password', { email });
      } catch (err) {
        if (!err.response) {
          setBackendError(t('errors.something went wrong'));
          return;
        }
        const { status } = err.response;
        if (status === NOT_FOUND) {
          setError('email', { message: t('errors.user not found') });
        } else {
          setBackendError(t('errors.something went wrong'));
        }
      }
    },
    [setError, t]
  );

  const emailIsRequired = t('errors.email is required');

  return (
    <>
      <AuthForm onSubmit={handleSubmit(onSubmit)} noValidate>
        <Row>
          <span style={{ textAlign: 'center' }}>{t('recover password.enter email')}</span>
        </Row>
        <div style={{ height: '20px' }} />
        <TextField
          autoComplete="new-password"
          helperText={errors.email && errors.email.message}
          error={!isEmpty(errors.email)}
          label={t('label.email')}
          inputRef={register({
            pattern: { message: t('errors.email is not valid'), value: /\S+@\S+\.\S+/ },
            required: emailIsRequired
          })}
          name="email"
          type="email"
          style={{ marginBottom: '16px', width: '400px' }}
          variant="outlined"
        />
        {backendError && <FormHelperText style={{ color: '#f44336' }}>{backendError}</FormHelperText>}
        <Row justifyContent="space-between" width="400px" margin="20px 0 0">
          <Button
            variant="outlined"
            color="secondary"
            style={{ height: '44px', width: '128px' }}
            onClick={() => {
              history.push('/');
            }}
          >
            {t('label.back')}
          </Button>
          <Button variant="contained" color="primary" type="submit" style={{ height: '44px', width: '150px' }}>
            {t('recover password.request code')}
          </Button>
        </Row>
      </AuthForm>
      <RecoverCode />
    </>
  );
};

export { RecoverPassword };
